import '../App.css';
import React, {useState, useEffect, Fragment} from 'react';
import { Link, useNavigate } from "react-router-dom";
import charactersSame from '../assets/searching.js';
import { grabData } from "../assets/dataUploader";

function DisplayGlossary() {

  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const [wordList, setWordList] = useState([]);
  const [fullList, setFullList] = useState({});
  const [displayEnglish, setEnglish] = useState(true);
  const navigate = useNavigate();

  const englishletters = ['English', 'All',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 
  'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P',
  'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
  ];

  const yorubaletters = ['Yoruba', 'Gbogbo',
  'A', 'B', 'D', 'E', 'Ẹ', 'F', 
  'G', 'Gb', 'H', 'I', 'J', 'K', 
  'L', 'M', 'N', 'O', 'Ọ', 'P',
  'R', 'S', 'Ṣ', 'T', 'U', 'W', 'Y'
  ];

  useEffect(() => {
    const getData = async () => {
      grabData().then(
        data => {
          setData(data);
          // console.log("Data found!");
          window.sessionStorage.setItem("database", JSON.stringify(data));

          const words = [];
          const alphabetOrder = {yoruba: {}, english: {}};
          //Populate original word list
          Object.keys(data).forEach((topic) => {
            data[topic].forEach((word) => {
              words.push(word);

              //Populate alphabet list, yoruba
              for (let i = 2; i < yorubaletters.length; i++){
                let yLetter = yorubaletters[i];
                if(charactersSame(word.yoruba_1[0], yLetter)){
                  if (alphabetOrder.yoruba[yLetter] === undefined){
                    alphabetOrder.yoruba[yLetter] = [];
                  }
                  alphabetOrder.yoruba[yLetter].push(word);
                }
              }
              
              //Populate alphabet list, english
              let place = word.english_1[0].toUpperCase();

              if (!isNaN(parseInt(place))){
                //It's a number!
                place = "Other";
              }

              if(alphabetOrder.english[place] === undefined){
                  alphabetOrder.english[place] = [];
              }
              alphabetOrder.english[place].push(word);
            })
          });

          setFullList(alphabetOrder);
          setWordList(words);
          // console.log(fullList);
        }
      ).then(
        _ => {
          setLoaded(true);
        }        
      )
    }

    if (!loaded){
      getData();
    }
  });

  const sortByEnglish = (reverse, wL) => {

    if (wL == null){
      wL = [...wordList];
    }

    wL.sort(function(word1, word2){
      if (reverse){
        return word2.english_1.localeCompare(word1.english_1);
      }else{
        return word1.english_1.localeCompare(word2.english_1);
      }
    });

    // console.log(wL);

    setWordList(wL);
  }

  const sortByYoruba = (reverse, wL) => {
    //sort data for render
    if (wL == null){
      wL = [...wordList];
    }

    wL.sort(function(word1, word2){
      if (!reverse) {
        return word1.yoruba_1.localeCompare(word2.yoruba_1);
      }else{
        return word2.yoruba_1.localeCompare(word1.yoruba_1);
      }
    });

    setWordList(wL);
  }

  const updateDisplayWord = (word) => {
    window.sessionStorage.setItem("displayWord", JSON.stringify(word));
    navigate("/word");
  }

  const handleLetterClick = (ch, idx) => {
    if (idx === 0){
      if (!displayEnglish){
        sortByEnglish(false);
      }else{
        sortByYoruba(false);
      }
      setEnglish(!displayEnglish);
    }else if (idx === 1){
      //Clicked All
      let words = [];
      //Populate original word list
      Object.keys(data).forEach((topic) => {
        data[topic].forEach((word) => {
          words = words.concat([word]);
        })
      });

      // console.log(words);
      setWordList([...words]);

      //Order
      if (displayEnglish){
        sortByEnglish(false, words);
      }else{
        sortByYoruba(false, words);
      }
    }else{
      //Order
      if (displayEnglish){
        const ll = fullList.english[ch];
        setWordList([...ll]);
        sortByEnglish(false, ll);
      }else{
        const ll = fullList.yoruba[ch];
        setWordList([...ll]);
        sortByYoruba(false, ll);
      }

      // console.log(wordList);
    }
  }

  return (
    <div className="Home">
      <header className="App-header">
        <h3 style={{textAlign:"center"}}>The Yoruba Dictionary</h3>

        <div className="special-characters">
          {displayEnglish? 
          englishletters.map((char, index) => (
            index === 0 ? (
              <button key={index} className="topic-item" onClick={() => handleLetterClick(char, index, englishletters)}> {char} </button>
            ) : (
              <button key={index} className="char-button" onClick={() => handleLetterClick(char, index, englishletters)}> {char} </button>
            )
          )) : 
          yorubaletters.map((char, index) => (
            index === 0 ? (
              <button key={index} className="topic-item" onClick={() => handleLetterClick(char, index, yorubaletters)}> {char} </button>
            ) : (
              <button key={index} className="char-button" onClick={() => handleLetterClick(char, index, yorubaletters)}> {char} </button>
            )
          ))}
        </div>

        <br />

        {/* In order to clarify, the actual word display begins here*/}
        <div className="grid-container">
          {wordList.map((word, index) => (
            <Link key={index} className="grid-item" onClick={() => {updateDisplayWord(word)}}>
              {displayEnglish ? 
              word.english_1 : word.yoruba_1}
              <br />
            </Link>
          ))}
        </div>
      </header>
    </div>
  );
}
  
export default DisplayGlossary;